<template>
  <div class="home-details">
    <page-header :title="title" />
    <div class="pet-home-container grey lighten-5 pa-3 pt-1">
      <v-row class="mt-3" no-gutters>
        <v-col cols="12" sm="4" md="3" class="d-flex justify-center pa-0 ma-0">
          <div
            class="
              d-flex
              flex-fill
              justify-center justify-sm-start
              ml-1
              mb-2 mb-md-4
            "
          >
            <v-avatar
              v-if="pet.data.fotoPerfil === '::restrict::'"
              :size="
                $vuetify.breakpoint.smAndDown
                  ? '156'
                  : $vuetify.breakpoint.mdAndDown
                  ? '140'
                  : '160'
              "
              :tile="!$vuetify.breakpoint.smAndDown"
              @click="showPhotoFullscreen = false"
              :title="$t('restrito_usuario')"
            >
              <v-icon
                style="
                  position: absolute;
                  top: -40px;
                  left: -50px;
                  opacity: 0.65;
                "
                size="30"
                >mdi-lock</v-icon
              >
              <v-img style="opacity: 0.4" src="/img/person-avatar.png" alt="" />
            </v-avatar>
            <v-avatar
              v-else
              :size="
                $vuetify.breakpoint.smAndDown
                  ? '156'
                  : $vuetify.breakpoint.mdAndDown
                  ? '140'
                  : '160'
              "
              :tile="!$vuetify.breakpoint.smAndDown"
              @click="showPhotoFullscreen = true"
            >
              <div
                v-if="
                  $store.getters['pet/isRestrict']('fotoPerfil') &&
                  $store.state.auth.user.token
                "
                :style="
                  $vuetify.breakpoint.mobile
                    ? 'position: absolute; top: 12px; left: 25px; z-index: 1'
                    : 'position: absolute; top: 7px; left: 7px; z-index: 1'
                "
              >
                <v-icon
                  size="40px"
                  color="grey lighten-2"
                  style="margin-bottom: 2px; opacity: 0.8"
                  dark
                  >mdi-lock</v-icon
                >
              </div>
              <v-img
                :src="
                  !pet.data.fotoPerfil
                    ? '/img/person-avatar.png'
                    : $store.state.profileImageURL + pet.data.fotoPerfil
                "
                alt=""
              />
            </v-avatar>
            <photo-fullscreen
              v-model="showPhotoFullscreen"
              :img="
                !pet.data.fotoPerfil
                  ? '/img/person-avatar.png'
                  : $store.state.profileImageURL + pet.data.fotoPerfil
              "
            />
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="8"
          md="9"
          class="d-flex flex-column justify-start pl-sm-8 pl-lg-5 m-0"
        >
          <div v-if="pet.data.nome || !$store.state.hideNoFilled">
            <restrict-icon
              :is-restrict="$store.getters['pet/isRestrict']('nome')"
            />
            <label class="text-caption grey--text text--darken-2">
              {{ $t("Nome") }}
            </label>
            <restrict-chip :value="pet.data.nome">
              <div v-if="pet.data.nome" class="title">
                {{ pet.data.nome | toPT_BRCapitalize }}
              </div>
              <div v-else>
                <i class="text-caption grey--text text--darken-1">
                  {{ noInfo }}
                </i>
              </div>
            </restrict-chip>
          </div>
          <div class="d-flex flex-wrap">
            <div
              v-if="pet.data.idade || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pet/isRestrict']('idade')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Idade") }}
              </label>
              <restrict-chip :value="pet.data.idade">
                <div v-if="pet.data.idade" class="subtitle-2">
                  {{ pet.data.idade }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pet.data.especie || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pet/isRestrict']('especie')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Especie") }}
              </label>
              <restrict-chip :value="pet.data.especie">
                <div v-if="pet.data.especie" class="subtitle-2">
                  {{ pet.data.especie | toPT_BRCapitalize }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pet.data.raca || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pet/isRestrict']('raca')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Raca") }}
              </label>
              <restrict-chip :value="pet.data.raca">
                <div v-if="pet.data.raca" class="subtitle-2">
                  {{ pet.data.raca | toPT_BRCapitalize }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pet.data.sexo || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pet/isRestrict']('sexo')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Sexo") }}
              </label>
              <restrict-chip :value="pet.data.sexo">
                <div v-if="pet.data.sexo" class="subtitle-2">
                  {{ pet.data.sexo | toPT_BRCapitalize }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="
                convertValue(pet.data.castrado, { type: 'boolean' }) ||
                !$store.state.hideNoFilled
              "
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pet/isRestrict']('castrado')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Castrado") }}
              </label>
              <restrict-chip :value="pet.data.castrado">
                <div
                  v-if="convertValue(pet.data.castrado, { type: 'boolean' })"
                  class="subtitle-2"
                >
                  {{ convertValue(pet.data.castrado, { type: "boolean" }) }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="
                convertValue(pet.data.pedigree, { type: 'boolean' }) ||
                !$store.state.hideNoFilled
              "
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pet/isRestrict']('pedigree')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Pedigree") }}
              </label>
              <restrict-chip :value="pet.data.pedigree">
                <div
                  v-if="convertValue(pet.data.pedigree, { type: 'boolean' })"
                  class="subtitle-2"
                >
                  {{ convertValue(pet.data.pedigree, { type: "boolean" }) }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pet.data.statusPet || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pet/isRestrict']('statusPet')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Status_Pet") }}
              </label>
              <restrict-chip :value="pet.data.statusPet">
                <div v-if="pet.data.statusPet" class="subtitle-2">
                  {{ pet.data.statusPet | toPT_BRCapitalize }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <v-col cols="12" class="pa-0">
              <div class="d-flex flex-wrap">
                <div v-if="pet.data.chip" class="mr-6 my-2">
                  <restrict-icon
                    :is-restrict="$store.getters['pet/isRestrict']('chip')"
                  />
                  <label class="text-caption grey--text text--darken-2">
                    {{ $t("Chip") }}
                  </label>
                  <restrict-chip :value="pet.data.chip">
                    <div v-if="pet.data.chip" class="subtitle-2">
                      {{ pet.data.chip }}
                    </div>
                    <div v-else>
                      <i class="text-caption grey--text text--darken-1">
                        {{ noInfo }}
                      </i>
                    </div>
                  </restrict-chip>
                </div>
                <div v-if="pet.data.rga" class="mr-6 my-2">
                  <restrict-icon
                    :is-restrict="$store.getters['pet/isRestrict']('rga')"
                  />
                  <label class="text-caption grey--text text--darken-2">
                    {{ $t("Rga") }}
                  </label>
                  <restrict-chip :value="pet.data.rga">
                    <div v-if="pet.data.rga" class="subtitle-2">
                      {{ pet.data.rga }}
                    </div>
                    <div v-else>
                      <i class="text-caption grey--text text--darken-1">
                        {{ noInfo }}
                      </i>
                    </div>
                  </restrict-chip>
                </div>
              </div>
            </v-col>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div class="mr-6 my-2">
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Localizacao") }}
              </label>
              <div class="subtitle-2 grey--text text--darken-2">
                <v-icon small color="orange darken-3">mdi-map-marker</v-icon>
                <small
                  class="text-decoration-underline"
                  style="cursor: pointer"
                  @click="showGetLocation = true"
                  >{{ $t("click_para_obter_localizacao") }}</small
                >
                <geolocation v-model="showGetLocation" />
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div
              v-if="pet.data.nomeDono || !$store.state.hideNoFilled"
              class="d-flex flex-wrap"
            >
              <div class="mr-6 my-2">
                <restrict-icon
                  :is-restrict="$store.getters['pet/isRestrict']('nomeDono')"
                />
                <label class="text-caption grey--text text--darken-2">
                  {{ $t("Dono") }}
                </label>
                <restrict-chip :value="pet.data.nomeDono">
                  <div v-if="pet.data.nomeDono" class="subtitle-2">
                    {{ pet.data.nomeDono | toPT_BRCapitalize }}
                  </div>
                  <div v-else>
                    <i class="text-caption grey--text text--darken-1">
                      {{ noInfo }}
                    </i>
                  </div>
                </restrict-chip>
              </div>
            </div>
            <div
              v-if="pet.data.foneDono || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pet/isRestrict']('foneDono')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Telefone_Dono") }}
              </label>
              <restrict-chip :value="pet.data.foneDono">
                <div v-if="pet.data.foneDono" class="subtitle-2">
                  {{ pet.data.foneDono }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pet.data.nomeCuidador || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pet/isRestrict']('nomeCuidador')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Cuidador") }}
              </label>
              <restrict-chip :value="pet.data.nomeCuidador">
                <div v-if="pet.data.nomeCuidador" class="subtitle-2">
                  {{ pet.data.nomeCuidador | toPT_BRCapitalize }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pet.data.foneCuidador || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pet/isRestrict']('foneCuidador')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Telefone_Cuidador") }}
              </label>
              <restrict-chip :value="pet.data.foneCuidador">
                <div v-if="pet.data.foneCuidador" class="subtitle-2">
                  {{ pet.data.foneCuidador }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div
              v-if="pet.data.medicamentos || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pet/isRestrict']('medicamentos')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Medicamentos") }}
              </label>
              <restrict-chip :value="pet.data.medicamentos">
                <div v-if="pet.data.medicamentos" class="subtitle-2">
                  {{ pet.data.medicamentos | toPT_BRCapitalize }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div
              v-if="pet.data.doencas || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pet/isRestrict']('doencas')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Doencas") }}
              </label>
              <restrict-chip :value="pet.data.doencas">
                <div v-if="pet.data.doencas" class="subtitle-2">
                  {{ pet.data.doencas | toPT_BRCapitalize }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div
              v-if="pet.data.alergiaAlimentar || !$store.state.hideNoFilled"
              class="alergias mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['pet/isRestrict']('alergiaAlimentar')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Alergia_Alimentos") }}
              </label>
              <restrict-chip :value="pet.data.alergiaAlimentar">
                <div v-if="pet.data.alergiaAlimentar" class="subtitle-2">
                  {{ pet.data.alergiaAlimentar | toPT_BRCapitalize }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pet.data.alergiaMedicamento || !$store.state.hideNoFilled"
              class="alergias mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['pet/isRestrict']('alergiaMedicamento')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Alergia_Medicamentos") }}
              </label>
              <restrict-chip :value="pet.data.alergiaMedicamento">
                <div v-if="pet.data.alergiaMedicamento" class="subtitle-2">
                  {{ pet.data.alergiaMedicamento | toPT_BRCapitalize }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pet.data.alergiaOutros || !$store.state.hideNoFilled"
              class="alergias mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pet/isRestrict']('alergiaOutros')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Outras_Alergias") }}
              </label>
              <restrict-chip :value="pet.data.alergiaOutros">
                <div v-if="pet.data.alergiaOutros" class="subtitle-2">
                  {{ pet.data.alergiaOutros | toPT_BRCapitalize }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div
              v-if="pet.data.nomeVeterinario || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['pet/isRestrict']('nomeVeterinario')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Veterinario") }}
              </label>
              <restrict-chip :value="pet.data.nomeVeterinario">
                <div v-if="pet.data.nomeVeterinario" class="subtitle-2">
                  {{ pet.data.nomeVeterinario | toPT_BRCapitalize }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pet.data.foneVeterinario || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['pet/isRestrict']('foneVeterinario')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Telefone_Clinica") }}
              </label>
              <restrict-chip :value="pet.data.foneVeterinario">
                <div v-if="pet.data.foneVeterinario" class="subtitle-2">
                  {{ pet.data.foneVeterinario }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
            <div
              v-if="pet.data.empresaVeterinario || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="
                  $store.getters['pet/isRestrict']('empresaVeterinario')
                "
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Clinica") }}
              </label>
              <restrict-chip :value="pet.data.empresaVeterinario">
                <div v-if="pet.data.empresaVeterinario" class="subtitle-2">
                  {{ pet.data.empresaVeterinario | toPT_BRCapitalize }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="m-0">
          <div class="d-flex flex-wrap">
            <div
              v-if="pet.data.informacoes || !$store.state.hideNoFilled"
              class="mr-6 my-2"
            >
              <restrict-icon
                :is-restrict="$store.getters['pet/isRestrict']('informacoes')"
              />
              <label class="text-caption grey--text text--darken-2">
                {{ $t("Outras_Informacoes") }}
              </label>
              <restrict-chip :value="pet.data.informacoes">
                <div v-if="pet.data.informacoes" class="subtitle-2">
                  {{
                    pet.data.informacoes | capitalize({ onlyFirstLetter: true })
                  }}
                </div>
                <div v-else>
                  <i class="text-caption grey--text text--darken-1">
                    {{ noInfo }}
                  </i>
                </div>
              </restrict-chip>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <Form :title="title" :data="pet" />
  </div>
</template>

<script>
/* eslint-disable prettier/prettier */
import i18next from "i18next";
import MixinGlobal from "@/mixins";
import PageHeader from "@/components/headers/page-header";
import PhotoFullscreen from "@/components/modals/photo-fullscreen";
import Form from "./form";
import Geolocation from "@/components/maps/geolocation";
import RestrictChip from "@/components/chips/restrict-chip";
import RestrictIcon from "@/components/icons/restrict-icon";

export default {
  metaInfo: {
    titleTemplate: (i18next.t("Perfil") || "") + " | %s",
  },
  mixins: [MixinGlobal],
  components: {
    RestrictIcon,
    RestrictChip,
    Geolocation,
    PhotoFullscreen,
    PageHeader,
    Form,
  },
  data: () => ({
    noInfo: "__",
    title: i18next.t("Perfil"),
    showPhotoFullscreen: false,
    showGetLocation: false,
  }),
  computed: {
    store() {
      return this.$store.state;
    },
    pet() {
      return this.$store.state.pet;
    },
  },
  mounted() {
    this.$nextTick(this.checkFilled);
  },
  methods: {
    checkFilled() {
      const filleds = [
        "nome",
        "idade",
        "raca",
        "castrado",
        "pedigree",
        "nomeDono",
        "foneDono",
        "nomeCuidador",
        "foneCuidador",
        "medicamentos",
        "doencas",
        "alergiaAlimentar",
        "alergiaMedicamento",
        "alergiaOutros",
        "nomeVeterinario",
        "foneVeterinario",
        "empresaVeterinario",
        "informacoes",
      ].map((key) => {
        return !!this.pet.data[key];
      });

      this.$store.commit("setAllFilled", !filleds.includes(false));
    },
  },
};
</script>

<style lang="scss">
.pet-home {
  @media (min-width: 1025px) {
    &-container {
      overflow: hidden auto;
      height: 520px;
      min-height: 520px;
      max-height: 520px;
    }
  }

  .v-avatar {
    background-color: #fff;
    border: solid 1px #e5e5e5;
  }
}
</style>
